import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import {
  VpButton,
  VpStripeInputs,
  VpHookFormWrapper,
  useCreateStripeToken,
  useVpSnackbar
} from '../../';
import { useCreateCard } from '../../../hooks';

const buttonContainerStyles = {
  display: 'grid',
  gridAutoFlow: 'column',
  justifyContent: 'space-between'
};

export const AddCardDialogContent = ({
  onClose = null,
  isUpdate = true,
  closeOnSuccess = true
}) => {
  const { addSnackbarSuccess } = useVpSnackbar();
  const { isStripeLoading, createToken, data } = useCreateStripeToken();
  const { isSuccess, isLoading: isCreateLoading, mutate } = useCreateCard();

  const isLoading = isStripeLoading || isCreateLoading;
  useEffect(() => {
    if (data) {
      mutate({ data });
    }
  }, [data]);

  useEffect(() => {
    if (isSuccess) {
      addSnackbarSuccess({
        message: 'Successfully added card'
      });
      onClose && closeOnSuccess && onClose();
    }
  }, [isSuccess]);

  const onSubmit = () => {
    createToken();
  };
  const onCloseClick = () => {
    onClose && onClose();
  };

  return (
    <VpHookFormWrapper onSubmit={onSubmit}>
      <VpStripeInputs />
      <Box sx={buttonContainerStyles}>
        <VpButton
          onClick={onCloseClick}
          disabled={isLoading}
          variant="contained"
          size="large"
          color="neutral"
        >
          Cancel
        </VpButton>
        <VpButton loading={isLoading} type="submit" variant="contained" size="large">
          {isUpdate ? 'Update Card' : 'Add Card'}
        </VpButton>
      </Box>
    </VpHookFormWrapper>
  );
};

AddCardDialogContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  isUpdate: PropTypes.bool,
  closeOnSuccess: PropTypes.bool
};

export default AddCardDialogContent;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpAddCardDialog/AddCardDialogContent.jsx